import React from 'react';
import { connect } from 'react-redux';
import { closeAddMemoDialog } from 'store/common/commonActions';
import { addMemo } from 'store/reclamation/reclamationsActions';
import AddMemoDialog from './AddMemoDialog';



const AddMemoDialogContainer = ({ open, reclamationId, isAdding, reclamation, closeAddMemoDialog, addMemo, utilisateurCourant }) => {

    const [text, setText] = React.useState("");
    const [fichiersIds, setFichiersIds] = React.useState([]);

    React.useEffect(() => {
        setText("");
        setFichiersIds([]);
    }, [open]);


    const handleClickSave = () => {
        addMemo(reclamationId, text, fichiersIds);
    };

    const handleClickCancel = () => {
        closeAddMemoDialog();
    };

    const handleChange = (e) => {
        if (e.target.name === "text") {
            setText(e.target.value);
        }
        if (e.target.name === "fichiersIds") {
            setFichiersIds(e.target.value);
        }
    };


    if (!open || !utilisateurCourant) return null;


    let sauvegardable = text !== undefined && text !== null && text.length > 0;



    // RECLA-715
    // Le bouton question-réponse est desactivé lorsqu'un est soit même l'émetteur
    let memoWarning = "";
    if (reclamation.emetteur.id === utilisateurCourant.id) {

        if (!reclamation.affectationUtilisateur) {
            memoWarning = "Ce dossier après-vente n'a pas encore été affecté, votre message sera sans suite.";
        }
        else {
            if (reclamation.affectationUtilisateur.id === utilisateurCourant.id) {
                memoWarning = "Ce dossier après-vente vous est affecté, votre message sera sans suite.";
            }
        }
    }



    return (
        <AddMemoDialog
            open={open}
            onClickSave={handleClickSave}
            onClickCancel={handleClickCancel}
            reclamationId={reclamationId}
            text={text}
            onChange={handleChange}
            isAdding={isAdding}
            sauvegardable={sauvegardable}

            memoWarning={memoWarning}
        />
    );
};



const mapStateToProps = state => {

    let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

    return (
    {
        open: state.common.addMemoDialogOpen,
        isAdding: state.common.memo.isAdding,
        reclamationId: state.common.memo.reclamationId,
        reclamation: state.reclamation.details.item,
        utilisateurCourant: utilisateurCourant
    });
};

const mapDispatchToProps = dispatch => ({
    addMemo: (reclamationId, text, fichiersIds) => dispatch(addMemo(reclamationId, text, fichiersIds)),
    closeAddMemoDialog: () => dispatch(closeAddMemoDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMemoDialogContainer);